<template>
  <div ref="entryProducts">
    <p class="text-size-20">応募する商品</p>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="entry-product entry-product-input" ref="entryProductInput">
          <ul class="nav nav-tabs">
            <li class="active"><a data-toggle="tab" href="#product-list">商品一覧</a></li>
            <li><a data-toggle="tab" href="#enter-list">リスト入力</a></li>
            <li><a data-toggle="tab" href="#upload-list">アップロード</a></li>
          </ul>
          <div class="tab-content" ref="tabContent">
            <available-products
              id="product-list"
              class="tab-pane fade in active"
              :products="displayProducts"
              :addedAsins="addedAsins"
              @handleSearch="handleSearch"
              @handleAddProduct="handleAddProduct"
              @handleAddProducts="handleAddProducts"
            />
            <enter-list
              id="enter-list"
              class="tab-pane fade"
              @setAddedAsins="setAddedAsins"
            />
            <upload-list
              id="upload-list"
              class="tab-pane fade"
              @setAddedAsins="setAddedAsins"
            />
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-md-12">
        <added-products
          class="entry-product entry-product-added"
          :class="{'has-entry': addedProducts.length > 0}"
          :products="addedProducts"
          @handleRemoveProduct="handleRemoveProduct"
          @handleRemoveProducts="handleRemoveProducts"
          @openModalConfirm="openModalConfirm"
          ref="entryProductAdded"
        />
      </div>
    </div>
    <modal-confirm
      v-if="isShowModalConfirm"
      :message="confirmMessage"
      @confirm="handlePostSaleEntry"
      @close="closeModalConfirm"
    />
    <modal-alert
      v-if="isShowModalAlert"
      :message="alertMessage"
      :customHide="true"
      :modalWidth="650"
      @close="closeModalAlert"
    />
  </div>
</template>

<script>
import SaleService from '@/services/salemasterservice'
import AvailableProducts from './SaleEntryAvailableProducts'
import EnterList from './SaleEntryInputList'
import UploadList from './SaleEntryUploadList'
import AddedProducts from './SaleEntryAddedProducts'
import ModalConfirm from '@/components/ModalConfirm'
import ModalAlert from '@/components/ModalAlert'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    AvailableProducts,
    EnterList,
    UploadList,
    AddedProducts,
    ModalConfirm,
    ModalAlert
  },
  data () {
    return {
      loader: null,
      availableProducts: [],
      displayProducts: [],
      addedAsins: [],
      isShowModalConfirm: false,
      confirmMessage: '選択した商品でセールへのエントリーを行います。よろしいですか？',
      isShowModalAlert: false,
      alertMessage: `
        エントリーが完了しました。 <br>
        エントリー内容はエントリー履歴画面からご確認いただけます。<br>
        募集期間中は、エントリー履歴画面から内容の編集を行っていただくことができます。
      `
    }
  },
  computed: {
    saleId () {
      return this.$route.params.saleId
    },
    addedProducts () {
      return this.availableProducts.filter(product =>
        this.addedAsins.includes(product.asin)
      )
    }
  },
  mounted () {
    this.getSaleEntry()
    this.$nextTick(() => {
      $(this.$el).find('a[data-toggle="tab"]').on('shown.bs.tab', () => {
        this.measureTabContentHeight()
      })
    })
    window.addEventListener('resize', this.unsetTabContent)
  },
  methods: {
    measureTabContentHeight () {
      const inputEl = this.$refs.entryProductInput
      const addedEl = this.$refs.entryProductAdded.$el

      if (!inputEl || !addedEl) return

      const activePane = this.$refs.tabContent.querySelector('.tab-pane.active')
      if (activePane && activePane.id === 'product-list') {
        const inputHeight = inputEl.getBoundingClientRect().height
        const addedHeight = addedEl.getBoundingClientRect().height
        const maxHeight = Math.max(inputHeight, addedHeight)
        inputEl.style.height = `${maxHeight}px`
        addedEl.style.height = `${maxHeight}px`
      } else {
        inputEl.style.height = ''
        addedEl.style.height = ''
      }
    },
    unsetTabContent () {
      const inputEl = this.$refs.entryProductInput
      const addedEl = this.$refs.entryProductAdded.$el
      inputEl.style.height = ''
      addedEl.style.height = ''
    },
    async sleep (time = 500) {
      await new Promise(resolve => setTimeout(resolve, time))
    },
    loading (container) {
      this.loader = this.$loading.show({
        container: container,
        backgroundColor: 'rgba(255,255,255,0.7)',
        canCancel: false,
        width: 40,
        height: 40,
        zIndex: 1000
      })
    },
    async getSaleEntry () {
      this.loading(this.$refs.entryProducts)
      await SaleService.getSaleEntry({ saleId: this.saleId })
        .then((response) => {
          this.availableProducts = response.data.availableProducts
          this.displayProducts = response.data.availableProducts
          this.addedAsins = response.data.addedAsins
          setTimeout(() => {
            this.measureTabContentHeight()
          }, 200)
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    async handleSearch (keyword) {
      const logParams = {
        name: eventCode.sale.entry.product_list.search,
        properties: {
          saleId: this.saleId,
          keyword: keyword
        }
      }
      EventService.postTrackLog(logParams)
      this.loading(this.$refs.tabContent)
      await this.sleep()
      if (!keyword) {
        this.displayProducts = [...this.availableProducts]
        this.loader && this.loader.hide()
        return
      }

      const lower = str => str.toLowerCase()
      const matchIncludes = (target, keyword) => lower(target || '').includes(lower(keyword || ''))
      this.displayProducts = [...this.availableProducts].filter(item => {
        const keywordMatch =
          matchIncludes(item.asin, keyword) ||
          matchIncludes(item.productName, keyword) ||
          matchIncludes(item.sku, keyword) ||
          matchIncludes(item.fnsku, keyword) ||
          (item.skus && (Object.values(item.skus).map(value => lower(String(value))).includes(lower(keyword)))) ||
          (item.skus && (Object.keys(item.skus).map(value => lower(String(value))).includes(lower(keyword))))
        if (!keywordMatch) return false
        return true
      })
      this.loader && this.loader.hide()
    },
    handleAddProduct (asin) {
      this.addedAsins.push(asin)
      const logParams = {
        name: eventCode.sale.entry.product_list.add,
        properties: {
          saleId: this.saleId,
          asin: asin
        }
      }
      EventService.postTrackLog(logParams)
    },
    handleAddProducts () {
      this.addedAsins = this.displayProducts.map(i => i.asin)
      const logParams = {
        name: eventCode.sale.entry.product_list.add_all,
        properties: {
          saleId: this.saleId
        }
      }
      EventService.postTrackLog(logParams)
    },
    handleRemoveProduct (asin) {
      const logParams = {
        name: eventCode.sale.entry.delete,
        properties: {
          saleId: this.saleId,
          asin: asin
        }
      }
      EventService.postTrackLog(logParams)

      this.addedAsins = this.addedAsins.filter(item => item !== asin)
    },
    handleRemoveProducts () {
      this.addedAsins = []
      const logParams = {
        name: eventCode.sale.entry.delete_all,
        properties: {
          saleId: this.saleId
        }
      }
      EventService.postTrackLog(logParams)
    },
    openModalConfirm () {
      this.isShowModalConfirm = true
    },
    closeModalConfirm () {
      $('#confirm-alert').modal('hide')
      this.isShowModalConfirm = false
    },
    openModalAlert () {
      this.isShowModalAlert = true
    },
    closeModalAlert () {
      $('#myModal').modal('hide')
      this.isShowModalAlert = false
      this.$router.push({ name: 'Sale' })
    },
    async handlePostSaleEntry () {
      if (this.addedAsins.length === 0) {
        return false
      }

      const logParams = {
        name: eventCode.sale.entry.submit,
        properties: {
          saleId: this.saleId
        }
      }
      EventService.postTrackLog(logParams)

      this.closeModalConfirm()
      this.loading(this.$refs.entryProducts)
      const params = {
        saleId: this.saleId,
        asins: this.addedAsins
      }
      await SaleService.postSaleEntry(params)
        .then((response) => {
          this.openModalAlert()
          this.$emit('updateSale')
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    setAddedAsins (asins) {
      this.addedAsins = [...new Set([...this.addedAsins, ...asins])]
    }
  },
  watch: {
    addedAsins () {
      this.$emit('settingDisabled', this.addedAsins.length === 0)
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
    window.removeEventListener('resize', this.unsetTabContent)
  }
}
</script>
<style scoped>
.entry-product {
  min-height: 500px;
  max-height: 1000px;
  border: 1px solid #ccc;
  margin-bottom: 10px;
}
.entry-product-input {
  background-color: #fff;
  .nav {
    background-color: #eee;
  }
  .nav-tabs {
    border: unset;
  }
  .nav-tabs > li > a {
    border: unset;
  }
  .tab-content {
    padding: 10px;
  }
}
.entry-product-added {
  background-color: #eee;
  padding: 10px;
}
.has-entry {
  background-color: #f2f8ee;
}
@media (min-width: 1440px) {
  .col-lg-12 {
    width: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/sale/components/SaleEntryProducts.vue